import dynamic from 'next/dynamic';
import type { Step } from '../flows';
export const hh: Step[] = [{
  step: 'wrapping-up',
  screenViewEvent: {
    name: 'wrapping_up'
  },
  Component: dynamic(() => import('../../WrappingUp/WrappingUp').then(module => module.WrappingUp), {
    ssr: false
  }),
  bgColor: 'mint',
  navBgColor: 'mint'
}, {
  step: 'reservation',
  screenViewEvent: {
    name: 'fix_date'
  },
  Component: dynamic(() => import('../../Reservation/Reservation').then(module => module.Reservation), {
    ssr: false
  }),
  showNavTitle: true
}, {
  step: 'finalize',
  screenViewEvent: {
    name: 'confirm_first_fix'
  },
  Component: dynamic(() => import('../../Finalize/Finalize').then(module => module.Finalize), {
    ssr: false
  }),
  hideNav: true,
  bgColor: 'mint',
  navBgColor: 'mint'
}];